// extracted by mini-css-extract-plugin
export var externalLink = "_5o-0";
export var internalLinkLabel = "_5o-1";